module.exports = __webpack_public_path__ + "static/media/12.1fa569eb.svg";